import templateStr from 'text!./templates/wizard-content.html';

export default ['StateUtils', function (StateUtil) {
    return {
        replace: true,
        transclude: true,
        template: templateStr,
        require: '^?gwPortalNavBar',
        link: function link(scope, element, attrs, navBarCtrl) {
            function moveToTopOfElement() {
                var alignElementToTopOfBrowserWindow = true;
                element[0].scrollIntoView(alignElementToTopOfBrowserWindow);
            }

            StateUtil.subscribeToStateTransitions(moveToTopOfElement);

            scope.$on('$destroy', function () {
                StateUtil.unsubscribeFromStateTransitions(moveToTopOfElement);
            });
            scope.sidebarMenuVisible = function () {
                return navBarCtrl.isSideBarMenuVisible();
            };
            if (navBarCtrl) {
                scope.hideSidebarMenu = function () {
                    navBarCtrl.hideSideBarMenu();
                };
            }
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/wizard/WizardContentDirective.js
// module id = 790
// module chunks = 0